<template>
  <div class="user" @click="adminshow">
    <el-card class="box-card">
      <div slot="header">
        <!-- 标题 -->
        <span class="font-sz24">部门管理</span>
        <el-button type="primary" @click="addDeptDialog2" class="adddept"
          >添加部门</el-button
        >
      </div>
      <!-- <el-row>
        <el-col :span="24">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/homePage' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>部门管理</el-breadcrumb-item>
            <el-breadcrumb-item>部门列表</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>-->
      <!-- <span class="jinggao">最多添加三级部门，多余不给予显示</span> -->
      <!-- 这里是表格 -->
      <div class="bm-table">
        <el-table
          v-loading="loading"
          :data="tableData"
          class="w100-marbot20"
          row-key="ID"
          border
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <!-- <el-table-column prop="ID" align="center" label="部门ID" sortable></el-table-column> -->
          <el-table-column
            type="index"
            align="center"
            label="序号"
            sortable
            width="300px"
          ></el-table-column>
          <el-table-column
            prop="label"
            align="center"
            label="部门名称"
            sortable
          ></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="addEditDialog(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="primary"
                plain
                @click="addDeptDialog(scope.row)"
                >添加子部门</el-button
              >
              <el-button
                size="small"
                type="danger"
                plain
                @click="showDeleteDialog(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 这里是分页 -->
      <!-- <el-pagination
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[10, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>-->

      <!-- 编辑 -->
      <el-dialog :close-on-click-modal = "false"
        title="编辑部门"
        :visible.sync="seeDialogFormVisible1"
        ref="editUserForm"
      >
        <el-form :model="editForm" label-width="80px" ref="editUserForm">
          <el-form-item label="部门名称" prop="dept02">
            <el-input
              v-model="editForm.dept02"
              auto-complete="off"
              placeholder="请输入部门名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editUserSubmit('editUserForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 添加 -->
      <el-dialog :close-on-click-modal = "false" :title="texts" :visible.sync="addDeptDialog1">
        <el-input
          v-model="dept"
          auto-complete="off"
          placeholder="请输入部门名称"
        ></el-input>
        <el-button type="primary" @click="adddept2" class="adddeptbtn"
          >确 定</el-button
        >
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
//引入
// import {} from "@/api";
// excel导出
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  GetProjectDept,
  AddCompanyDept,
  DelCompanyDept,
  FindCompanyDept,
  EditCompanyDept
} from "@/setAxios.js";
export default {
  name: "deptManagement",
  data() {
    return {
      texts: "添加部门",
      //用户id
      userID: "",
      // inject:['reload'],
      loading: false,
      fid: 0,
      value1: "",
      tableData: [],
      query: "",
      total: 0,
      pagesize: 10,
      pagenum: 1,
      // 这里是父级ID
      PID: "",
      dept: "",
      //###修改数据
      seeDialogFormVisible1: false,
      addDeptDialog1: false,
      multipleSelection: [],
      editForm: {}
    };
  },
  //   模型初始化时调用方法请求接口
  created() {
    this.getData();
  },
  methods: {
    // 导出表格所用
    exportExcel() {
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = year + "" + month + "" + day;
      // //(name)
      /* generate workbook object from table */
      //  .table要导出的是哪一个表格
      var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        // if (typeof console !== "undefined") //(e, wbout);
      }
      return wbout;
    },
    // 删除部门
    showDeleteDialog(row) {
      this.$confirm("此操作将永久删除该部门，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        DelCompanyDept({ ids: row.ID }).then(res => {
          if (res.Code == 1) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getData();
          } else if (res.Code == -1) {
            this.$message({
              message: "部门下存在用户,无法删除",
              type: "warning"
            });
          } else if (res.Code == 0) {
            this.$message({
              message: "删除失败",
              type: "warning"
            });
          }
        });
      });
    },
    getData() {
      this.loading = true;
      let params = {
        pid: localStorage.getItem("pid")
      };
      GetProjectDept({ params })
        .then(res => {
          //(res);
          this.tableData = res.Data;
          this.loading = false;
          this.total = res.total;
        })
        .catch(err => {
          //(err);
        });
    },
    //显示编辑用户对话框
    addEditDialog(row) {
      this.seeDialogFormVisible1 = true;
      let params = {
        id: row.ID
      };
      FindCompanyDept({ params }).then(res => {
        this.editForm = res.Data;
      });
    },
    //编辑部门
    editUserSubmit() {
      EditCompanyDept({ model: JSON.stringify(this.editForm) }).then(res => {
        if (res.Code == 1) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.seeDialogFormVisible1 = false;
          this.getData();
        } else {
          this.$message({
            message: "修改失败",
            type: "warning"
          });
        }
        this.seeDialogFormVisible1 = false;
        this.getData();
      });
    },
    // 添加
    addDeptDialog(row) {
      //(row);
      this.addDeptDialog1 = true;
      this.fid = row.ID;
      this.texts = "添加子部门";
    },
    // 添加根级部门
    addDeptDialog2(row) {
      this.addDeptDialog1 = true;
      this.texts = "添加主部门";
    },
    adddept2() {
      if (this.dept.length > 0) {
        let params = {
          dept01: 0,
          dept02: this.dept,
          dept03: localStorage.getItem("pid"),
          dept04: new Date(),
          dept05: this.fid
        };
        AddCompanyDept({ model: params }).then(res => {
          if (res.Code == 1) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.getData();
            this.addDeptDialog1 = false;
          }
        });
      } else {
        this.$message({
          message: "部门名称不能为空",
          type: "warning"
        });
      }
    },
    adddept() {
      if (this.dept.length > 0) {
        let params = {
          dept01: 0,
          dept02: this.dept,
          dept03: localStorage.getItem("pid"),
          dept04: new Date(),
          dept05: 0
        };
        AddCompanyDept({ model: JSON.stringify(params) }).then(res => {
          if (res.Code == 1) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.getData();
            this.addDeptDialog1 = false;
          }
        });
      } else {
        this.$message({
          message: "部门名称不能为空",
          type: "warning"
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      //   //(`每页 ${val} 条`)
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //   //(`当前页: ${val}`)
      // //("当前页码"+this.pagesize)
      this.pagenum = val;
      this.getData();
    },
    // 关闭菜单栏显示
    adminshow() {
      this.$emit("update:showAdmin", true);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 20px;
}
.user .margin-20 {
  margin: 20px 0;
}
.user .search-input {
  width: 300px;
}
.user .page {
  padding: 5px 0;
  background-color: #d3dce6;
}
.user {
  .btnArr {
    margin-top: 10px;
  }
}
.adddept {
  float: right;
  margin-bottom: 20px;
}
.adddeptbtn {
  margin-top: 20px;
  margin-left: 90%;
}
.jinggao {
  font-size: 20px;
  color: red;
  height: 56px;
  line-height: 56px;
}
.bm-table {
  /deep/ .is-leaf {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      left: 24px;
      // background: url('../../assets/img/mx.png');
      background-size: 100%;
    }
  }
  /deep/ .is-leaf:nth-child(2) {
    &::before {
      top: 18px;
      background: url("../../assets/img/bmmc.png");
      background-size: 100%;
      left: 35%;
    }
  }
  /deep/ .is-leaf:nth-child(1) {
    &::before {
      top: 18px;
      background: url("../../assets/img/ztt.png");
      background-size: 100%;
      left: 35%;
    }
  }
  /deep/ .is-leaf:nth-child(3) {
    &::before {
      top: 18px;
      background: url("../../assets/img/cz.png");
      background-size: 100%;
      left: 40%;
    }
  }
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.w100-marbot20 {
  width: 100%;
  margin-bottom: 20px;
}
</style>
